import { styled } from 'baseui'
import { FlexBetween } from '@/shared/theme/styled-components'

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '0rem',
}))

export const StyledTopContainer = styled('div', () => ({
  width: '100%',
  padding: '1rem 1rem 0rem 1rem',
}))

export const StyledHeader = styled(FlexBetween, {
  marginBottom: '1rem',
})

export const StyledTitle = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: $theme.colors.textHeading,
}))

export const UpdatedAt = styled('div', ({ $theme }) => ({
  fontSize: '0.75rem',
  color: $theme.colors.textDimmed,
  marginBottom: '0.5rem',
}))

export const GrayBlock = styled('div', {
  width: '100%',
})

export const GrayBlockContent = styled('div', ({ $theme }) => ({
  backgroundColor: $theme.colors.white,
  borderRadius: '0.375rem',
  padding: '0.55rem',
  color: $theme.colors.primaryAlt,
  lineHeight: 1.4,
}))

export const OuterCard = styled('div', ({ $theme }) => ({
  backgroundColor: $theme.colors.bgSoft,
  padding: '1rem',
  marginBottom: '10px',
  fontSize: '0.875rem',
}))

export const Header = styled('div', ({ $theme }) => ({
  fontWeight: 600,
  color: $theme.colors.textDeep,
  display: 'flex',
  alignItems: 'center',
  fontSize: '1rem',
}))

export const StyledEmptyState = styled('div', ({ $theme }) => ({
  fontStyle: 'italic',
  color: $theme.colors.textLight,
  textAlign: 'center',
  margin: '2rem 0',
}))
